import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Search.svg'

export const IconSearch = IconSVG as IconComponent
